function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "no-photo_svg__a",
  d: "M138.773.113v.57H0v-.57h138.773z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#7EADBC",
  d: "M104.24 25.903C104.24 11.597 92.623 0 78.29 0 63.958 0 52.34 11.597 52.34 25.903c0 14.305 11.618 25.902 25.95 25.902 14.332 0 25.95-11.597 25.95-25.902"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M125.102 16.53a.234.234 0 01-.234-.232v-1.46a2.632 2.632 0 015.216-.498 1.93 1.93 0 013.44 1.2v.758a.234.234 0 01-.234.233h-8.188z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7EADBC",
  d: "M125.102 16.53a.234.234 0 01-.234-.232v-1.46a2.632 2.632 0 015.216-.498 1.93 1.93 0 013.44 1.2v.758a.234.234 0 01-.234.233h-8.188z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#639CA5",
  d: "M55.56 38.403c4.42 7.989 12.94 13.402 22.73 13.402 4.17 0 8.106-.987 11.597-2.731L57.174 11.227l-1.613 27.176z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M8.467 21.356a.505.505 0 01-.505-.505v-3.154c0-3.13 2.551-5.678 5.688-5.678a5.695 5.695 0 015.585 4.6 4.172 4.172 0 017.434 2.591v1.641a.505.505 0 01-.505.505H8.467z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7EADBC",
  d: "M8.467 21.356a.505.505 0 01-.505-.505v-3.154c0-3.13 2.551-5.678 5.688-5.678a5.695 5.695 0 015.585 4.6 4.172 4.172 0 017.434 2.591v1.641a.505.505 0 01-.505.505H8.467z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#E1F3F9",
  d: "M9.811 61.49L48.028 4.92c1.556-2.304 4.072-2.283 5.591.045l34.125 52.292c1.52 2.328 4.018 2.336 5.552.018l14.525-21.95c1.534-2.317 4.045-2.317 5.579 0l17.916 26.923"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7EADBC",
  d: "M9.811 61.49L48.028 4.92c1.556-2.304 4.072-2.283 5.591.045l34.125 52.292c1.52 2.328 4.018 2.336 5.552.018l14.525-21.95c1.534-2.317 4.045-2.317 5.579 0l17.916 26.923"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C6DFE5",
  d: "M101.239 61.995a32.96 32.96 0 00-21.51-7.943 32.963 32.963 0 00-21.512 7.943h43.022z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#C6DFE5",
  d: "M119.458 60.985a32.96 32.96 0 00-21.51-7.943 32.963 32.963 0 00-21.511 7.943h43.021z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M65.744 44.001a.663.663 0 01-.664-.663v-4.143c0-4.112 3.351-7.457 7.47-7.457a7.48 7.48 0 017.337 6.043 5.475 5.475 0 014.286-2.066c3.02 0 5.478 2.454 5.478 5.469v2.154a.663.663 0 01-.664.663H65.744z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7EADBC",
  d: "M65.744 44.001a.663.663 0 01-.664-.663v-4.143c0-4.112 3.351-7.457 7.47-7.457a7.48 7.48 0 017.337 6.043 5.475 5.475 0 014.286-2.066c3.02 0 5.478 2.454 5.478 5.469v2.154a.663.663 0 01-.664.663H65.744z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M46.11 16.618c6.98 3.902 8.656-3.623 13.403-2.508l.032-.065-5.926-9.08c-1.52-2.329-4.035-2.348-5.591-.045l-7.453 11.031c.71-.64 2.27-1.158 5.535.667"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7EADBC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M46.11 16.618c6.98 3.902 8.656-3.623 13.403-2.508l.032-.065-5.926-9.08c-1.52-2.329-4.035-2.348-5.591-.045l-7.453 11.031c.71-.64 2.27-1.158 5.535.667z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M110.89 40.587c2.233 1.672 4.258.682 5.48-.774l-2.97-4.487c-1.534-2.319-4.045-2.319-5.579 0l-3.407 5.148s4.242-1.56 6.476.113"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7EADBC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M110.89 40.587c2.233 1.672 4.258.682 5.48-.774l-2.97-4.487c-1.534-2.319-4.045-2.319-5.579 0l-3.407 5.148s4.242-1.56 6.476.113z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#A9B504",
  d: "M111.867 61.49a32.96 32.96 0 00-21.511-7.943 32.963 32.963 0 00-21.51 7.943h43.02z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  stroke: "#989B15",
  d: "M111.867 61.49a32.96 32.96 0 00-21.511-7.943 32.963 32.963 0 00-21.51 7.943h43.02z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#A9B504",
  d: "M123.424 61.49a14.674 14.674 0 00-9.576-3.536 14.674 14.674 0 00-9.577 3.536h19.153z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  stroke: "#989B15",
  d: "M123.424 61.49a14.674 14.674 0 00-9.576-3.536 14.674 14.674 0 00-9.577 3.536h19.153z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#A9B504",
  d: "M25.243 61.49a14.674 14.674 0 00-9.577-3.536A14.674 14.674 0 006.09 61.49h19.153z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  stroke: "#989B15",
  d: "M25.243 61.49a14.674 14.674 0 00-9.577-3.536A14.674 14.674 0 006.09 61.49h19.153z"
});

var _ref24 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.016 61.882)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "no-photo_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#no-photo_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E1F3F9",
  d: "M0 .113h138.773",
  mask: "url(#no-photo_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7EADBC",
  d: "M0 .113h138.773",
  mask: "url(#no-photo_svg__b)"
}));

const SvgNoPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 140 63"
}, props), _ref, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.5
}, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f6f6",
  d: "M0 0h139.175v62.984H0z",
  style: {
    mixBlendMode: "color"
  }
})));

export default SvgNoPhoto;